import { getWebAPIUrl } from '../../../services/env.service';
import {
  DishCategoryResponse,
  DeliveryInfoResponse,
  DeliveryInfoDish,
  DishesResponse
} from './types';

const webApiUrL = getWebAPIUrl();

class WebsiteClient {
  getDishCategories() {
    const url = `${webApiUrL}/dish_categories?filter[order]=order`;
    return this.getJSON<DishCategoryResponse>(url);
  }

  getDeliveryInfo(postalCode: number, customerNumber: number) {
    const mealserviceDepartmentId = 1;
    const url = `${webApiUrL}/delivery-info/${postalCode}/${mealserviceDepartmentId}/${customerNumber}`;
    return this.getJSON<DeliveryInfoResponse>(url);
  }

  getDishes(weekNumber: number) {
    const mealserviceDepartmentId = 1;
    let url = `${webApiUrL}/dishes`;
    url += `?filter[include]=dish_portions`;
    url += `&filter[where][and][0][week_number]=${weekNumber}`;
    url += `&filter[where][and][1][department_id]=${mealserviceDepartmentId}`;
    url += `&filter[where][and][2][type][eq]=Maaltijdservice`;
    url += `&filter[where][and][3][category][neq]=Maaltijdpakket`;
    url += `&filter[order]=dish_number ASC`;

    return this.getJSON<DishesResponse>(url);
  }

  getDishById(dishId: number) {
    let url = `${webApiUrL}/dishes/${dishId}`;
    url += `?filter[include]=dish_portions`;
    return this.getJSON<DeliveryInfoDish>(url);
  }

  getJSON<T>(url: string): Promise<T> {
    return fetch(url).then<T>(response => response.json());
  }
}

const websiteClient = new WebsiteClient();

export { websiteClient };
